<div class="policy-container">
  <button class="mobile-btn" type="button" mat-button (click)="back()"><i class="fas fa-chevron-left"></i></button>
  <div class="title">
    აირჩიე პოლისი
  </div>
  <form [formGroup]="form">
    <div class="upper-row">
      <div class="col-xl-6 col-lg-6 col-md-6">
        <div class="d-flex flex-wrap">
          <div class="left">
            <mat-checkbox formControlName="franchise" class="example-margin">ფრანშიზა</mat-checkbox>
          </div>
          <div class="right">
            <mat-checkbox formControlName="covid" class="example-margin">კოვიდ დაფარვა</mat-checkbox>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 currency-switch">
        <span>სადაზღვევო ლიმიტის ვალუტა</span>
        <button class="switch cur-p" type="button" (click)="insurance.currency=(insurance.currency=='€')?'$':'€'">
          <img [hidden]="insurance.currency=='€'" src="../../../../assets/img/usd.svg">
          <img [hidden]="insurance.currency=='$'" src="../../../../assets/img/eur.svg">
        </button>
      </div>
    </div>

    <div class="data-policy">
      <div class="row mt-3" style="margin-bottom: -15px;" *ngFor="let p of options; last as isLast; let i = index;">
        <div class="col-12">
          <div class="hidden-radio choose-policy">
            <input type="radio" formControlName="policy" value="{{p.value}}" id="{{p.value}}">
            <label for="{{p.value}}">
              <div class="row align-items-center d-flex">
                <div class="first">
                  <h3>{{p.name}}</h3>
                  <h2>{{p.price}}₾</h2>
                </div>
                <div class="second">
                  <span>{{p.description}}</span>
                </div>
                <div class="third">
                  <p>ლიმიტი</p>
                  <p>{{p.limit | currencySign: insurance.currency}}</p>
                  <button class="btn btn-primary more"
                  type="button"
                    id="btn"
                    (click)='openAccordion[i] = !openAccordion[i]; toggleState(p);'
                    data-bs-toggle="collapse"
                    [attr.data-target]="'#collapse' + i"
                    aria-expanded="true"
                    [attr.aria-controls]="'collapse' + i"
                    [class.button-open]="!slideOpen"
                    [class.button-close]="slideOpen"
                    ><i [@iconState]="p.state" class="fas fa-chevron-down" id="icon"
                    ></i> დეტალურად</button>
                  </div>
                  <div class="mobile-text">
                    <span>ჯანმრთელობის რისკები</span>
                  </div>
              </div>
            </label>
          </div>
        </div>
        <div class="col-12">
          <div class="data"
          *ngFor="let d of p.details; last as isLast; let a = index;"
          [id]="'collapse' + i"
          class="accordion-collapse collapse"
          [class.show]='openAccordion[i]'
          [attr.aria-labelledby]="'heading' + i"
          data-bs-parent="#accordionExample">
            <div class="row">
              <div class="col">
                <div>
                 <div class="policy-data">
                   <div class="policy-title">
                    {{d.leftSide}}
                   </div>
                   <div class="policy-type">
                      <button
                      (click)="openAccordion2[a] = !openAccordion2[a]; d.state = d.state === 'active' ? 'inactive' : 'active';"
                      data-bs-toggle="collapse2"
                      [attr.data-target]="'#collapse2' + a"
                      aria-expanded="true"
                      [attr.aria-controls]="'collapse2' + a"
                        >
                        {{d.rightSide | currencySign: insurance.currency }}
                        <i class="ms-2 fas fa-chevron-down" id="icon" [@iconState]="d.state"></i> </button>
                   </div>
                 </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="collapse multi-collapse"
                [id]="'collapse2' + a"
                class="accordion-collapse collapse"
                [class.show]='openAccordion2[a]'
                [attr.aria-labelledby]="'heading2' + a"
                >
                <div class="policy-desc">
                  {{d.description}}
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd">
      <app-prev-btn *ngIf="desktop"></app-prev-btn>
      <app-next-btn (click)="onSubmit()"></app-next-btn>
    </div>
  </form>
</div>
